import { render, staticRenderFns } from "./verifyJavaUser.vue?vue&type=template&id=60c49b8b&scoped=true&"
import script from "./verifyJavaUser.vue?vue&type=script&lang=js&"
export * from "./verifyJavaUser.vue?vue&type=script&lang=js&"
import style0 from "./verifyJavaUser.vue?vue&type=style&index=0&id=60c49b8b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c49b8b",
  null
  
)

export default component.exports